module.exports = ".user-input {\n  font-size: 24px;\n  font-weight: 900;\n  color: #009fe7;\n}\n.btn-invite {\n  padding: 15px; \n  background: #009FE8;\n  color: white;\n  outline: none;\n  font-weight: 700;\n}\n.modal-footer {\n  text-align: center;\n}\n.mat-form-field {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/welcome/reset-password-model/reset-password-model.component.css
// module id = ./src/app/modules/user/components/welcome/reset-password-model/reset-password-model.component.css
// module chunks = main